import { render, staticRenderFns } from "./AssetsCalculation.vue?vue&type=template&id=80e02254&"
import script from "./AssetsCalculation.vue?vue&type=script&lang=js&"
export * from "./AssetsCalculation.vue?vue&type=script&lang=js&"
import style0 from "./AssetsCalculation.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports